<template>
  <div :class=" statusType === 'error' ? 'alert-error inline' : 'form-actions-message'">
    <translation :text="lang.get(status)" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Translation from '../../interface-text/components/Translation';

export default {
  name: 'Status',
  inject: ['lang'],
  components: {
    Translation
  },
  computed: {
    statusType() {
      if (!this.isValid || !this.isSaveable || this.configurationMode || (this.apiMessageType == 'error')) {
        return 'error';
      }
      return '';
    },
    status() {
      if (this.configurationMode) {
        return 'entries.form.buttons-deactivated-config';
      }
      if (this.uploadInProgress) {
        return 'entries.form.buttons-deactivated';
      }
      if (!this.isValid) {
        return 'entries.form.invalid';
      }
      if (!this.isSaveable) {
        return this.chapters.length > 1
          ? 'entries.form.incomplete.multi-chapter'
          : 'entries.form.incomplete.single-chapter';
      }
      return this.entry &&
        this.entry.submittedAt &&
        !this.entry.resubmissionRequired &&
        !this.apiStatusMessage
        ? 'entries.messages.submitted'
        : this.apiStatusMessage;
    },
    ...mapState('entryFormApi', { apiStatusMessage: 'Message', apiMessageType: 'MessageType' }),
    ...mapState('entryForm', ['entry', 'uploadInProgress', 'chapters']),
    ...mapGetters('entryForm', ['isValid', 'isSaveable']),
    ...mapState('entryFormConfiguration', ['configurationMode'])
  }
};
</script>

<style scoped></style>
